export const setTooltipPosition = (container, tooltip) => {
    tooltip.classList.remove(`top`);
    tooltip.classList.remove(`bottom`);
    tooltip.classList.remove(`left`);
    tooltip.classList.remove(`right`);

    const {top: slideTop, left: slideLeft, height: slideHeight, width: slideWidth} = container.getBoundingClientRect();
    const {top: tooltipTop, left: tooltipLeft} = tooltip.getBoundingClientRect();
    tooltipTop > slideTop + slideHeight / 2 ? tooltip.classList.add(`bottom`) : tooltip.classList.add(`top`); 
    tooltipLeft > slideLeft + slideWidth / 2 ? tooltip.classList.add(`right`) : tooltip.classList.add(`left`); 
};
